export default "__VITE_PUBLIC_ASSET__7532dcbe__"